export default "__VITE_ASSET__CfXkK$JJ__"